import { useMediaQuery, useTheme } from '@mui/material'
import { GridColumnVisibilityModel } from '@mui/x-data-grid'

/**
 * Returns a column visibility model that hides lower-priority columns at smaller breakpoints.
 * - lg+ (>=1200px): all columns visible
 * - md (900–1199px): hide updatedOn
 * - sm (600–899px): also hide tags, linkedCreditApp, receivedOn
 */
export const useResponsiveColumns = (): GridColumnVisibilityModel => {
  const theme = useTheme()
  const isLg = useMediaQuery(theme.breakpoints.up('lg'))
  const isMd = useMediaQuery(theme.breakpoints.up('md'))

  if (isLg) return {}

  if (isMd) {
    return {
      updatedOn: false,
    }
  }

  return {
    updatedOn: false,
    tags: false,
    linkedCreditApp: false,
    receivedOn: false,
  }
}
